// import React, { useState, useEffect } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";

// const BannerSection = () => {
//   const [user, loading, error] = useAuthState(auth);
//   const [bannerData, setBannerData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Convert YouTube URL to embed
//   const convertToEmbedUrl = (url) => {
//     if (!url) return "";
//     const regExp =
//       /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//     const match = url.match(regExp);
//     const videoId = match && match[2].length === 11 ? match[2] : null;
//     return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
//   };

//   // Fetch banner data
//   useEffect(() => {
//     const fetchBannerData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/banner-section");
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();
//         if (result.success) {
//           setBannerData(result.data);
//         } else {
//           setApiError(result.message || "Failed to fetch banner data");
//         }
//       } catch (err) {
//         console.error("Error fetching banner data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchBannerData();
//   }, []);

//   if (apiError) {
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading Banner</h4>
//         <p>{apiError}</p>
//         <button
//           className="btn btn-outline-danger"
//           onClick={() => window.location.reload()}
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   if (!bannerData || !bannerData.isActive) {
//     return null;
//   }

//   const embedUrl = convertToEmbedUrl(bannerData.youtubeUrl);
//   const backgroundImage = bannerData.backgroundImage;

//   return (
//     <>
//       <section className="gt-hero-section gt-hero-3">
//         <div className="hero-circle-shape">
//           <img src="assets/img/home-3/hero-circle.png" alt="img" />
//         </div>

//         <div className="container">
//           <div className="gt-hero-content">
//             <h1 className="char-animation">
//               {bannerData.mainTitle ||
//                 "The complete CRM solution built for your success"}
//             </h1>
//             <p className="wow fadeInUp" data-wow-delay=".3s">
//               {bannerData.description ||
//                 "All your customer data, tools, and insights in one unified platform."}
//             </p>

//             {bannerData.buttonText && bannerData.buttonLink && (
//               <a
//                 href={bannerData.buttonLink}
//                 className="gt-theme-btn style-3 bg-header mt-5"
//               >
//                 {bannerData.buttonText}
//               </a>
//             )}
//           </div>

//           <div className=""></div>

//           <div className="row mt-4">
//             <div className="col-lg-12 d-flex justify-content-center">
//               <div
//                 className="banner-dashboard float-bob-y"
//                 style={{
//                   width: "100%",
//                   maxWidth: "800px",
//                   position: "relative",
//                   overflow: "hidden",
//                   borderRadius: "20px",
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "relative",
//                     width: "100%",
//                     paddingTop: "56.25%", // 16:9 aspect ratio
//                   }}
//                 >
//                   {embedUrl ? (
//                     <iframe
//                       src={embedUrl}
//                       title="YouTube video"
//                       frameBorder="0"
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                       allowFullScreen
//                       style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         width: "100%",
//                         height: "100%",
//                         borderRadius: "20px",
//                       }}
//                     ></iframe>
//                   ) : (
//                     backgroundImage && (
//                       <img
//                         src={backgroundImage}
//                         alt="Banner"
//                         style={{
//                           position: "absolute",
//                           top: 0,
//                           left: 0,
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "cover",
//                           borderRadius: "20px",
//                         }}
//                       />
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Responsive style fix */}
//       <style jsx>{`
//         @media (max-width: 768px) {
//           .banner-dashboard {
//             max-width: 100% !important;
//             border-radius: 12px;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default BannerSection;


import React, { useState, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";

const BannerSection = () => {
  const [user, loading, error] = useAuthState(auth);
  const [bannerData, setBannerData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [playVideo, setPlayVideo] = useState(false); // NEW: video play toggle

  // Convert YouTube URL to embed
  const convertToEmbedUrl = (url) => {
    if (!url) return "";
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = match && match[2].length === 11 ? match[2] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : "";
  };

  // Get YouTube thumbnail
  const getThumbnailUrl = (url) => {
    if (!url) return null;
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = match && match[2].length === 11 ? match[2] : null;
    return videoId
      ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
      : null;
  };

  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/banner-section");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        if (result.success) {
          setBannerData(result.data);
        } else {
          setApiError(result.message || "Failed to fetch banner data");
        }
      } catch (err) {
        console.error("Error fetching banner data:", err);
        setApiError("Network error or server not responding");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBannerData();
  }, []);

  if (apiError) {
    return (
      <div className="alert alert-danger text-center py-5" role="alert">
        <h4>Error Loading Banner</h4>
        <p>{apiError}</p>
        <button
          className="btn btn-outline-danger"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }

  if (!bannerData || !bannerData.isActive) return null;

  const embedUrl = convertToEmbedUrl(bannerData.youtubeUrl);
  const thumbnailUrl = getThumbnailUrl(bannerData.youtubeUrl);
  const backgroundImage = bannerData.backgroundImage;

  return (


   

//     <> <section id="home" className="hero-area bgc-dark-blue rel z-1">
//   <div className="container">
//     <div className="row align-items-center">
//       <div className="col-lg-7 align-self-center">
//         <div className="hero-content text-white my-120 rmb-0 wow fadeInLeft delay-0-2s">
//           <span className="sub-title mb-35">{bannerData.highlightText}</span>
//           <h1>{bannerData.mainTitle}</h1>
//           <p>{bannerData.description}</p>
//           <div className="hero-btns pt-10">
//             <a href={bannerData.buttonLink} className="theme-btn mt-15">{bannerData.buttonText} <i className="fas fa-angle-double-right" /></a>
          
//           </div>
//         </div>
//       </div>
//       <div className="col-lg-5 align-self-end">
//         <div className="hero-images mt-75 wow fadeInRight delay-0-2s">
//           <img src={bannerData.subTitle} alt="Hero" />
//         </div>
//       </div>
//     </div>
//   </div>
//   <div className="wave-shapes">
//     <img className="shape one" src="assets/images/shapes/hero1.png" alt="Wave Shape" />
//     <img className="shape two" src="assets/images/shapes/hero2.png" alt="Wave Shape" />
//   </div>
// </section>
// </>

<><section className="cs_hero cs_style_1 cs_type_3 position-relative" id="home">
  <div className="container">
    <div className="cs_hero_content position-relative">
      <div className="row align-items-center cs_gap_y_40">
        <div className="col-lg-5 order-lg-2">
          <div className="cs_hero_thumbnail cs_radius_15 position-relative wow fadeInRight">
            <img src={bannerData.subTitle} alt="Hero Image" />
            <div className="cs_hero_shape_vector position-absolute">
              <img src="assets/img/quarter-circle.svg" alt="Vector Shape" />
            </div>
          
            
          </div>
        </div>
        <div className="col-lg-7 order-lg-1">
          <div className="cs_hero_text position-relative z-2">
            <h1 className="cs_hero_title cs_fs_68 wow fadeInDown">{bannerData.mainTitle} <span className="position-relative">
                {bannerData.highlightText}
                <img src="assets/img/vector.svg" alt="Vector line" className="cs_line_1 position-absolute" />
                <img src="assets/img/vector-2.svg" alt="Vector line" className="cs_line_2 position-absolute" />
              </span>
            </h1>
            <p className="cs_hero_subtitle">{bannerData.description}</p>
            <div className="cs_btn_group position-relative">
              <a href={bannerData.buttonLink} aria-label="Video open button" className="cs_btn cs_style_1 cs_purple_bg cs_white_color cs_video_open wow fadeInLeft"><span>{bannerData.buttonText}</span></a>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_blob_5 position-absolute" />
    </div>
  </div>
</section>
</>
  );
};

export default BannerSection;

